export default __webpack_public_path__ + "static/media/right-column-image.ee5ad62d.jpg";